import React from "react";

export const IntlContext = React.createContext(null);
